// File for logic corresponding to share component
import { Component } from 'js-component-framework';
import AriaPopup from 'js-component-framework/lib/plugins/AriaPopup';
import './index.scss';

/**
 * Component for share
 */
export default class Share extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.initShareMenuToggle();
    this.initShareLinkComments();
  }

  /**
   * Initialize share menu toggle
   */
  initShareMenuToggle() {
    const {
      shareToggle,
      shareMenu,
    } = this.children;

    // Do nothing if there is no controller and target.
    if (!shareMenu || !shareToggle) {
      return;
    }

    // Toggle the share menu when the share menu toggle is clicked.
    this.shareMenuDropdown = new AriaPopup({
      controller: shareToggle,
      target: shareMenu,
    });
  }

  /**
   * Initialize and handle moving the user to the comments element
   * with a offset to allow a more centered landing position.
   */
  initShareLinkComments() {
    const {
      shareLinkComments,
    } = this.children;

    if (!shareLinkComments) {
      return;
    }

    shareLinkComments.addEventListener('click', (e) => {
      e.preventDefault();
      const comments = document.getElementById('comments');
      const headerOffset = 180;

      if (comments) {
        const elementPosition = comments.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        // Scroll user to comments with an offset of 200px using scrollTo
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    });
  }
}
